/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_B11Inputs */

const en_job_form_enum_b11 = /** @type {(inputs: Job_Form_Enum_B11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B1 - Intermediate`)
};

const de_job_form_enum_b11 = /** @type {(inputs: Job_Form_Enum_B11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B1 - Fortgeschrittene Kenntnisse`)
};

/**
* | output |
* | --- |
* | "B1 - Intermediate" |
*
* @param {Job_Form_Enum_B11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_b11 = /** @type {((inputs?: Job_Form_Enum_B11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_B11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_b11(inputs)
	return en_job_form_enum_b11(inputs)
});
export { job_form_enum_b11 as "job_form_enum_B1" }